import DatabaseService from 'services/DatabaseService.js';
import {ADD_ANNOUNCEMENTS,
        SET_ANNOUNCEMENTS_END,
        CLEAR_ANNOUNCEMENTS}  from 'actions/types'
import {addChallenges}  from 'actions/challenges.js'
import {addUserChallenges}  from 'actions/userChallenges.js'

//Action Creators
export const setAnnouncementsEnd = () => {
    return { type:SET_ANNOUNCEMENTS_END };
}
export const addAnnouncements = (announcements, nextDate) => {
    return { type:ADD_ANNOUNCEMENTS, announcements:announcements, nextDate:nextDate };
}
export const clearAnnouncements = () => {
    return { type:CLEAR_ANNOUNCEMENTS };
}




//Thunks
export const fetchAnnouncementsPage = (date, limit) => (dispatch, getState) => {
    return new Promise(function(resolve, reject) {
        DatabaseService.fetchCompanyAnnouncementsFeed(date, limit).then(
            function(result){ 
                var announcements = result.announcements;
                if(result.announcements.length) {
                    var userChallenges = announcements.map(a => a.userChallenge).filter(uc => uc!==null);
                    var challenges = announcements.map(a => a.challenge).filter(c => c!==null);
                    announcements = announcements.map(a => ({...a, challenge:null, userChallenge : null}));
                    dispatch(addChallenges(challenges));
                    dispatch(addUserChallenges(userChallenges));
                    dispatch(addAnnouncements(announcements, result.summary.nextDate));
                } else {
                    dispatch(setAnnouncementsEnd());
                }
                resolve(result);
            },
            function(error){ 
                console.error(error);
                reject(error); 
            });
    });
}



// WEBPACK FOOTER //
// ./src/actions/announcements.js